import { Table } from 'antd';
import React from 'react';

import type { ExpenseByArticlesReportTableProps } from '@app/pages/Analytics/ExpenseByArticlesReport/types';
import { transformExpenseByArticlesReportToTableData } from '@app/pages/Analytics/ExpenseByArticlesReport/utils';

const HEADER_HEIGHT = 400;

export const ExpenseByArticlesReportTable: React.FC<
  ExpenseByArticlesReportTableProps
> = ({ isLoading, tableData }) => {
  const { dataSource, columns, expandedRowKeys } =
    transformExpenseByArticlesReportToTableData(tableData);

  return (
    <Table
      bordered
      columns={columns}
      dataSource={dataSource}
      pagination={false}
      loading={isLoading}
      className="expense-by-article-report-table table-border-dark"
      rowClassName={(record) => {
        if (record.key === 'total') return 'cash-table-total-row';
        if (typeof record.key === 'string' && record.key.startsWith('group-')) {
          return 'expense-parent-row';
        }
        return '';
      }}
      expandable={{
        expandedRowKeys: expandedRowKeys,
        expandIcon: () => null,
      }}
      scroll={{ x: 'max-content', y: `calc(100vh - ${HEADER_HEIGHT}px)` }}
    />
  );
};
